import { render } from "./ContentContainer.vue?vue&type=template&id=61b7c2df&scoped=true"
const script = {}

import "./ContentContainer.vue?vue&type=style&index=0&id=61b7c2df&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-61b7c2df"

export default script